import { degamma } from '../degamma';

import { BusylightStatus, Tone } from './busylightDeviceManager.types';

/** The devices supported by the BusylightDeviceManager */
export const busylightDeviceFilters = {
  legacyKuandoDevices: [
    { vendorId: 1240, productId: 63560 },
    { vendorId: 10171, productId: 15306 },
    { vendorId: 10171, productId: 15307 },
    { vendorId: 10171, productId: 15308 },
    { vendorId: 10171, productId: 15309 },
  ],
  supportedKuandoDevices: [{ vendorId: 1240 }, { vendorId: 10171 }],
};

/**
 * Information about at what positions in the buffer that is sent to the
 * busylight devices to store information about color, sound, steps and so
 * on...
 */
export const bufferPositions = {
  repeatInterval: 1,
  red: 2,
  green: 3,
  blue: 4,
  onTimeSteps: 5,
  offTimeSteps: 6,
  sound: 7,
};

/** The available ringtones on the busylight devices */
export const busylightRingtones: Tone[] = [
  'OpenOffice',
  'Quiet',
  'Funky',
  'FairyTale',
  'KuandoTrain',
  'TelephoneNordic',
  'TelephoneOriginal',
  'TelephonePickMeUp',
];

/**
 * The values for each ringtone to be set in the buffer array that are sent to
 * the devices
 */
export const tones: Record<Tone, number> = {
  OpenOffice: 136,
  Quiet: 144,
  Funky: 152,
  FairyTale: 160,
  KuandoTrain: 168,
  TelephoneNordic: 176,
  TelephoneOriginal: 184,
  TelephonePickMeUp: 192,
  Buzz: 216,
};

/** Pre-defined configurations for statuses */
export const busylightStatus: BusylightStatus = {
  busy: { color: { r: degamma(255), g: degamma(30), b: degamma(0) } },
  away: { color: { r: degamma(225), g: degamma(127), b: degamma(0) } },
  working: { color: { r: degamma(0), g: degamma(255), b: degamma(10) } },
  offline: { color: { r: degamma(0), g: degamma(0), b: degamma(0) } },
  alert: {
    color: { r: degamma(0), g: degamma(170), b: degamma(222) },
    onTimeSteps: 3,
    offTimeSteps: 5,
    repeatInterval: 120,
  },
};
